export default `/* Ids Time Picker Popup Component */
/* stylelint-disable no-invalid-position-declaration */
.hide {
  display: none;
}

@media all and (max-width: 2463px) {
  .hide-xxl-down {
    display: none;
  }
}

@media all and (min-width: 2463px) {
  .hide-xxl-up {
    display: none;
  }
}

@media all and (max-width: 1183px) {
  .hide-xl-down {
    display: none;
  }
}

@media all and (min-width: 1183px) {
  .hide-xl-up {
    display: none;
  }
}

@media all and (max-width: 928px) {
  .hide-lg-down {
    display: none;
  }
}

@media all and (min-width: 928px) {
  .hide-lg-up {
    display: none;
  }
}

@media all and (max-width: 927px) {
  .hide-md-down {
    display: none;
  }
}

@media all and (min-width: 927px) {
  .hide-md-up {
    display: none;
  }
}

@media all and (max-width: 767px) {
  .hide-sm-down {
    display: none;
  }
}

@media all and (min-width: 767px) {
  .hide-sm-up {
    display: none;
  }
}

@media all and (max-width: 320px) {
  .hide-xs-down {
    display: none;
  }
}

@media all and (min-width: 320px) {
  .hide-xs-up {
    display: none;
  }
}

ids-popup[visible][animated] {
  transition: none;
}

:host([hidden]) {
  display: none;
}

.ids-time-picker-popup::part(popup) {
  padding-block: var(--ids-space-none);
  background-color: var(--ids-time-picker-popup-color-background);
}
.ids-time-picker-popup .popup-btn {
  align-items: center;
  width: 100%;
}
.ids-time-picker-popup .popup-btn::part(button) {
  height: 100%;
  color: var(--ids-time-picker-popup-button-color-text-default);
  padding: var(--ids-space-none);
  padding-block: var(--ids-space-12);
  align-items: center;
  justify-content: center;
}
.ids-time-picker-popup ids-dropdown::part(trigger-field) {
  display: inline-flex;
  min-width: 75px;
}
.ids-time-picker-popup ids-list-box,
.ids-time-picker-popup ids-list-box-option {
  width: 100%;
}
.ids-time-picker-popup ids-list-box-option {
  padding-left: 4px;
}
.ids-time-picker-popup ids-popup::part(popup) {
  margin: var(--ids-space-none);
  padding: var(--ids-space-none);
}
.ids-time-picker-popup .dropdowns {
  display: flex;
  flex-direction: row;
  padding-inline-start: 20px;
  padding-inline-end: 20px;
  padding-top: 15px;
}
.ids-time-picker-popup .dropdown::part(trigger-field) {
  justify-content: center;
}
.ids-time-picker-popup .separator {
  width: 12px;
  display: inline-block;
  height: 38px;
  margin-top: 23px;
}
.ids-time-picker-popup .separator.colons {
  color: var(--ids-time-picker-popup-colons-color-text);
  width: 17px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 38px;
}
@media all and (max-width: 320px) {
  .ids-time-picker-popup .dropdowns {
    flex-direction: column;
    align-items: center;
    width: var(--ids-input-width-20);
  }
  .ids-time-picker-popup .separator {
    display: none;
  }
}

.ids-time-picker-popup[dir=rtl] ids-list-box-option {
  padding-right: 4px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
